import React from "react";

import { useTranslation } from "utils";

import { Flex, Icon, Modal, Trans, Typography } from "components";

export const DataSubmissionBarConfirmationModal = ({
  showConfirmationModal,
  setShowConfirmationModal,
  isSubmitting,
  setIsSubmitting,
  onSubmitClick,
}: {
  showConfirmationModal: boolean;
  setShowConfirmationModal: (show: boolean) => void;
  isSubmitting: boolean;
  setIsSubmitting: (isSubmitting: boolean) => void;
  onSubmitClick?: () => Promise<void>;
}) => {
  const { t } = useTranslation(["allFieldView"]);

  const handleSubmitClick = async () => {
    setIsSubmitting(true);
    await onSubmitClick?.();
    setIsSubmitting(false);
    setShowConfirmationModal(false);
  };

  return (
    <Modal
      showModal={showConfirmationModal}
      onCancel={() => setShowConfirmationModal(false)}
      onOk={handleSubmitClick}
      title={t("submissionBar.confirmationModal.title")}
      okText={t("submissionBar.confirmationModal.submit")}
      cancelText={t("submissionBar.confirmationModal.cancel")}
      className="submission-bar-confirmation-modal"
      loading={isSubmitting}
      destroyOnHidden
      content={
        <Flex vertical gap="1rem">
          <Typography variant="paragraph-m" className="margin-0">
            <Trans i18nKey={"allFieldView:submissionBar.confirmationModal.description"} components={{ strong: <strong /> }} />
          </Typography>
          <Flex className="submission-bar-confirmation-modal-info-banner" align="flex-start" justify="space-between" gap="0.5rem">
            <Icon iconName="tabler/info-circle" />
            <div>
              <ul>
                <li>
                  <Typography variant="paragraph-m" className="margin-0">
                    <Trans i18nKey={"allFieldView:submissionBar.confirmationModal.infoPoints.higherPayout"} components={{ strong: <strong /> }} />
                  </Typography>
                </li>
                <li>
                  <Typography variant="paragraph-m" className="margin-0">
                    <Trans i18nKey={"allFieldView:submissionBar.confirmationModal.infoPoints.lockAssessments"} components={{ strong: <strong /> }} />
                  </Typography>
                </li>
              </ul>
            </div>
          </Flex>
          <span className="line-divider" />
          <Typography variant="paragraph-m" className="margin-0">
            {t("submissionBar.confirmationModal.footer")}
          </Typography>
        </Flex>
      }
    />
  );
};
